import React, { useState, useEffect } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import { PanelFooter, PanelHeader } from 'components/Panel'

import { Offcanvas } from 'react-bootstrap'

function VerInformacion(props) {
	const { informacion, setQueMostrar } = props

	const handleClose = () => {
		setQueMostrar('')
	}

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Ver información" />
			<Offcanvas.Body>
				<h1>Datos de la información</h1>
				<Row>
					<Col sm={12} md={6}>
						<Table>
							<thead></thead>
							<tbody>
								<tr>
									<th>Id</th>
									<td>{informacion.id}</td>
								</tr>
								<tr>
									<th>Título</th>
									<td>{informacion.titulo}</td>
								</tr>
								<tr>
									<th>Orden</th>
									<td>{informacion.orden}</td>
								</tr>
							</tbody>
						</Table>
					</Col>
					<Col sm={12} md={6} className="text-center">
						<h3>Imagen</h3>
						<div className="logo-img">
							<img src={informacion.multimedia ? process.env.REACT_APP_API_URL + 'uploads/' + informacion.multimedia.url : 'logo192.jpg'} alt={informacion.titulo}/>
						</div>
					</Col>
				</Row>
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="primary" onClick={handleClose}>
					Ok
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default VerInformacion